export const GET_DASHBOARD_NOTIFICATION_REQUEST = "GET_DASHBOARD_NOTIFICATION_REQUEST"
export const GET_DASHBOARD_NOTIFICATION_SUCCESS = "GET_DASHBOARD_NOTIFICATION_SUCCESS"

export const GET_USER_NOTIFICATION_REQUEST = "GET_USER_NOTIFICATION_REQUEST"
export const GET_USER_NOTIFICATION_SUCCESS = "GET_USER_NOTIFICATION_SUCCESS"
export const GET_USER_NOTIFICATION_FAILURE = "GET_USER_NOTIFICATION_FAILURE"

export const UPDATE_UNREAD_NOTIFICATION_COUNT = "UPDATE_UNREAD_NOTIFICATION_COUNT"
